import * as React from 'react';
import Section from '../../components/Section';
import { ColorField } from '../../components/forms';
import { Product } from '../../product';
import ProductAppPreview from '../../components/ProductAppPreview';
import { Theme } from '../../company';
import * as color from 'tinycolor2';

type Props = {
  product: Product;
  children?: React.ReactNode;
  setProduct: Function;
};

const setThemeValue = (obj: Product, setProduct: Function) => (
  field: string,
  newValue: String,
) =>
  setProduct(
    Object.assign({}, obj, {
      theme: {
        ...obj.theme,
        [field]: newValue,
      },
    }),
  );

const checkColorCombination = (theme: Theme): string => {
  if (!color.isReadable(theme.background, theme.body)) {
    return 'The text is hard to read, please choose a brighter color';
  }

  if (!color.isReadable(theme.background, theme.key)) {
    return 'The primary color is hard to read with this background. please choose a brighter color';
  }

  if (color(theme.background).getBrightness() < 20) {
    return 'The Background color is too dark. Please choose a brighter color';
  }

  return '';
};

export default function ProductAppearance(props: Props) {
  const msg = checkColorCombination(props.product.theme);
  return (
    <Section title="Appearance" id="appearance">
      <div className="flex">
        <div className="flex-auto w-50 pr2">
          <ColorField
            label="Background Color"
            id="background"
            field={['background']}
            defaultValue={props.product.theme.background}
            onValueChange={setThemeValue(props.product, props.setProduct)}
          />
          <ColorField
            label="Highlight Color"
            id="key"
            field={['key']}
            defaultValue={props.product.theme.key}
            onValueChange={setThemeValue(props.product, props.setProduct)}
          />
          <ColorField
            label="Text Color"
            id="body"
            field={['body']}
            defaultValue={props.product.theme.body}
            onValueChange={setThemeValue(props.product, props.setProduct)}
          />
          {msg && <p className="pa3 bg-gold black b f5 br3">{msg}</p>}
        </div>
        <div className="flex-auto w-50 pl2">
          <ProductAppPreview product={props.product} />
        </div>
      </div>
    </Section>
  );
}
